<template>
    <div>
        <auth @authenticated="progress" v-bind:checkout="true"></auth>
    </div>
</template>

<script>
    export default {
        components: {
            'auth': require('../../auth/auth.vue'),
        },
        methods: {
            progress: function () {
                this.$router.push({
                    name : 'cart.participants',
                });
            }
        },
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// AccountDetails.vue?1e82db94